export default {
    categoryInvoice: 'invoice',
    categoryBug: 'bug',
    categoryFeatureRequest: 'featureRequest',
    categoryComment: 'comment',
    categoryReport: 'report',
    categoryLabel(category) {
        switch(category) {
            case this.categoryFeatureRequest:
                return Core.Definition.getDefinition('Nouvelle fonctionnalité');
                break
            case this.categoryReport:
                return Core.Definition.getDefinition('Nouveau rapport');
                break
            case this.categoryBug:
                return Core.Definition.getDefinition('Problème technique');
                break
            case this.categoryInvoice:
                return Core.Definition.getDefinition('Facture');
                break
            case this.categoryComment:
                return Core.Definition.getDefinition('Commentaire et suggestion');
                break
        }
    },
    categoryOptions(keys) {
        if (keys === undefined) {
            keys = [this.categoryFeatureRequest, this.categoryReport, this.categoryBug, this.categoryInvoice, this.categoryComment]
        }
        let options = []
        for(let key in keys) {
            key = keys[key]
            options.push(
                {
                    value: key,
                    label: this.categoryLabel(key)
                }
            )
        }
        return options
    },
}